export const getBackendUrl = () => {
  return window.location.href.indexOf('steamspartner.dd.poweredbycadworx.com/production/') > -1 ? 'https://backend.stahlsteam.com/api' : 'https://backend-staging.stahlsteam.com/api';
}